import type { DocStatus } from "../api/types";
import { STATUS_LABEL } from "../lib/format";

/**
 * The load-bearing status signal (design-system §1.3 / interaction principle 3:
 * every status is a colour + a dot + a word — never hue alone).
 *   delivered  → sage (success)
 *   draft      → ochre (warning)
 *   superseded → muted + strikethrough
 */
export function StatusBadge({ status }: { status: DocStatus }) {
  return (
    <span className={`badge badge--${status}`} data-testid={`status-${status}`}>
      <span className="badge__dot" aria-hidden />
      {STATUS_LABEL[status]}
    </span>
  );
}
